<template>
  <component :is="el" :prop="prop" :required="required">
    <template slot="label"><span><i v-if="icon" :class="icon">&nbsp;</i>{{label}}</span></template>

    <span v-if="noForm"><i v-if="icon" :class="icon">&nbsp;</i>{{label}}</span>

    <el-checkbox
      v-model="form"
      :disabled="disabled"
      @change="updated">
      <slot></slot>
    </el-checkbox>

  </component>

</template>

<script>

export default {
  name: 'check-box',

  props: {

    label: {
      type: String,
      default: null
    },

    name: {
      type: String
    },

    value: {
//      type: Boolean,
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    },

    icon: {
      type: String,
      default: null
    },

    helpText: {
      type: String,
      default: null
    },

    prop: {
      type: String,
      default: null
    },

    noForm: {
      type: Boolean,
      default: false
    }

  },



  methods: {

    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }

  },

  watch: {
    value: function (val) {
      this.form = val
    }
  },


  data () {
    return {
      form: this.value,
      el: this.noForm ? 'div' : 'el-form-item'
    }
  }
}
</script>
